import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Primary CTA — Profico Labs brand.
 */
export default function AccentButton({
  children,
  className,
  type = 'button',
  disabled,
  onClick,
  as: Component = 'button',
  variant = 'primary',
  ...rest
}) {
  const variants = {
    primary:
      'bg-space hover:bg-space/90 text-white rounded-lg disabled:opacity-50 transition-colors',
    secondary:
      'bg-elevated hover:bg-white/5 text-ink border border-shell-border rounded-lg disabled:opacity-50 transition-colors',
    space:
      'bg-space hover:bg-space/90 text-white rounded-lg disabled:opacity-50 transition-colors',
  };

  return (
    <Component
      type={Component === 'button' ? type : undefined}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center gap-2 text-sm font-medium px-4 py-2',
        variants[variant] || variants.primary,
        className,
      )}
      {...rest}>
      {children}
    </Component>
  );
}
